/**
 * Turning a number into a row of notches.
 *
 * Health and armour are both read at a glance in the middle of a fight, and
 * the question is never "what fraction am I on" but "how many more hits is
 * that". A smooth bar cannot answer it; a row of notches can, because each one
 * stands for a fixed amount and you count them rather than judge a length.
 *
 * Not hearts. A row of red hearts is the most recognisable thing in the game
 * this one is deliberately not copying, so these are notches on a bar - and
 * the health one is labelled сила, not health.
 *
 * Pure arithmetic: no DOM, no colours, no engine. What a notch looks like is
 * the UI's business, and how full it is is this file's.
 */

/** How full each notch is, 0..1, left to right. */
export function gaugeSegments(value: number, max: number, count: number): number[] {
  if (count <= 0) return [];
  const notches = new Array<number>(count).fill(0);
  if (max <= 0) return notches;

  const per = max / count;
  for (let i = 0; i < count; i++) {
    // Partial notches matter: a body on 1 hp with two hp to a notch must not
    // read as empty, or the player learns to trust the bar exactly when it
    // matters most.
    notches[i] = Math.max(0, Math.min(1, (value - i * per) / per));
  }
  return notches;
}

/** How many notches are showing anything at all. */
export function litSegments(segments: readonly number[]): number {
  return segments.filter((s) => s > 0).length;
}
